export default __webpack_public_path__ + "images/referenzen/imagefilm/chanel_16_9.mp4";